import { Component, EventEmitter, Input, Output } from '@angular/core';
import MatchSubmenuComponent from '@app/shared/common/match/match-submenu/match-submenu.component';
import SvgIconComponent from '@app/shared/svg-icon/svg-icon.component';

@Component({
    selector: 'app-match-label',
    imports: [SvgIconComponent, MatchSubmenuComponent],
    templateUrl: './match-label.component.html',
    styleUrls: ['./match-label.component.less'],
})
class MatchLabelComponent {
    @Input() text: string;

    @Output() onClick: EventEmitter<void> = new EventEmitter<void>();

    isMenuVisible = false;

    icon = 'add-circle';

    handleClick() {
        if (this.isMenuVisible) {
            this.icon = 'remove-circle';
        } else {
            this.icon = 'add-circle';
        }

        this.isMenuVisible = !this.isMenuVisible;
        this.onClick.emit();
    }
}

export default MatchLabelComponent;
